import { useState, useEffect } from 'react';

export default function AgeVerification() {
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem('age-verified');
    if (stored === 'true') {
      setVerified(true);
    }
  }, []);

  if (verified) return null;

  const handleConfirm = () => {
    localStorage.setItem('age-verified', 'true');
    setVerified(true);
  };

  const handleLeave = () => {
    window.location.href = 'about:blank';
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background-950/90 backdrop-blur-sm p-4">
      <div className="bg-background-100 rounded-xl border border-background-200/60 p-8 max-w-md w-full text-center">
        <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-500/15">
          <i className="ri-shield-user-line text-accent-500 text-2xl"></i>
        </div>
        <h2 className="text-xl font-bold font-heading text-foreground-950 mb-2">
          年龄确认
        </h2>
        <p className="text-sm text-foreground-500 mb-2 leading-relaxed">
          本网站包含成人向内容，仅供18岁及以上用户浏览。
        </p>
        <p className="text-xs text-foreground-400 mb-6 leading-relaxed">
          点击"我已满18岁"即表示您确认自己已达到法定成年年龄，并同意浏览本站的成人向内容。
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={handleConfirm}
            className="px-6 py-2.5 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            我已满18岁，进入网站
          </button>
          <button
            onClick={handleLeave}
            className="px-6 py-2.5 rounded-md bg-background-200 text-foreground-600 text-sm font-medium hover:bg-background-300 transition-colors whitespace-nowrap cursor-pointer"
          >
            我未满18岁，离开
          </button>
        </div>
      </div>
    </div>
  );
}